import React, { forwardRef } from 'react';
import { Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { setDraggedItem } from '../../Reducers/mileSpaceSlice';
import './itemsList.css';
import { ItemsEnum } from '../../Utils/enum';

const ItemList = forwardRef((props, ref) => {
    const dispatch = useDispatch();

    const handleDragStart = (item) => {
        dispatch(setDraggedItem(item));
    };

    return (
        <div className="item-list-container" ref={ref}>
            {Object.entries(ItemsEnum).map(([key, { title, icon }]) => (
                <Tooltip title={title} placement="right" key={key}>
                    <div
                        draggable
                        onDragStart={() => handleDragStart({ title: key, icon })}
                    >
                        <img src={icon} alt={title} className="item-icon" />
                    </div>
                </Tooltip>
            ))}
        </div>
    );
});

export default ItemList;
